import React from "react";
import BannerSection from "./banner_Section/BannerSection";
import LatestBlogs from "../../home/latest_blogs/LatestBlogs";
import HaveQuestion from "../../effects_page/category_tabs/fire/have_question/HaveQuestion";

export default function BlogInner() {
  return (
    <div>
      <BannerSection />
      <LatestBlogs />
      <HaveQuestion />
    </div>
  );
}
